import { StyleSheet } from 'react-native';
import { UIHelper as uh } from '../../core';

export const settingStyles = StyleSheet.create({
  // Main Root Container of the Application
  settingScreenContainer: {
    paddingLeft: uh.w2DP(16),
    paddingRight: uh.w2DP(16),
    paddingTop: uh.h2DP(20),
    paddingBottom: uh.h2DP(20)
  }
});
